import cn from 'classnames';
import { splitMarkdownLink } from '@chewy/chat-library-common';
import React from "react";
import styles from './OutsideRedirectUrl.module.scss';

export type OutsideRedirectUrlProps = {
  url: string;
  className?: string;
  linkAction?: (url: string) => void;
};

const OutsideRedirectUrl: React.FC<OutsideRedirectUrlProps> = ({ url, className, linkAction }) => {
  const result = splitMarkdownLink(url);
  const action = (event: React.MouseEvent) => {
    event.preventDefault();

    // do something with the url listed above.
    console.log(`going to ${result?.url || url}`);
    if (linkAction) {
      linkAction(result?.url || url);
    }
  };

  return (
    <span className={className ? cn(className, styles.defaultUrlScheme) : styles.defaultUrlScheme}>
      <a href={result?.url || url} onClick={action}>
        {result?.linkText || result?.url || url}
      </a>
    </span>
  );
};

export default OutsideRedirectUrl;

